import logo from '../../assets/images/rexolms.png'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { sidebar } from '../../redux/slices/assets'
import { SessionManager } from '../../utils'
import Menu from 'antd/es/menu'
import ConfigProvider from 'antd/es/config-provider'
import { Drawer } from 'antd'

export const SidebarImport = {
    ConfigProvider,
    Menu,
    Drawer,
    logo,
    useDispatch,
    useSelector,
    Link,
    useNavigate,
    useLocation,
    sidebar,
    SessionManager
}